// extracted by mini-css-extract-plugin
export default {"square":"LoginSquare_square__iIzkA","text":"LoginSquare_text__vK1Ba"};